import React, { useContext, useEffect } from 'react';
import DataContext from '../../context/Datacontext';
import { useTranslation } from 'react-i18next';
import './reservechear.css';
import useWindowSize from '../../hooks/useWindowSize';
// import io from 'socket.io-client';
import socketIOClient from 'socket.io-client';


const ReserveChear = () => {
    const {width} = useWindowSize();
    const { selectedTrip,lang,selectedChears,setSelectedChears,price,setPrice,chears,setChears,checkchears
        // ,socketChears,SetSocketChears
    } = useContext(DataContext);
    // const socket = io.connect("https://way-go.vercel.app/");
    // useEffect(()=>{
    //     socket.on("chearsStatus",(chear)=>{
    //     console.log(chear)
    //     SetSocketChears(chear);
    //     // console.log(socketChears)
    //     })
    //     // eslint-disable-next-line
    // },[socket]);
    // console.log(socketChears)
    useEffect(() => {
        const socket = socketIOClient('https://way-go.vercel.app:19991'); // Replace with your server's URL
        socket.on('connect', () => {
          console.log('Connected to the server');
    
          // Handle other events or emit data to the server
        });
    
        // Clean up the socket connection on component unmount
        return () => {
          socket.disconnect();
          console.log('socket canceled !')
        };
      }, []);
    const dateTime = new Date(selectedTrip?.date);
    const year = dateTime?.getFullYear();
    const month = String(dateTime?.getMonth() + 1).padStart(2, '0');
    const day = String(dateTime?.getDate()).padStart(2, '0');
    const hours = String(dateTime?.getHours()).padStart(2, '0');
    const minutes = String(dateTime?.getMinutes()).padStart(2, '0');
    const seconds = String(dateTime?.getSeconds()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    const formattedTime = `${hours}:${minutes}:${seconds}`;
    const dayOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const formattedDay = dayOfWeek[dateTime?.getDay()];
    const [t] = useTranslation("global");
    let fromser = '' , toser ='' , dayser = ''
    switch (selectedTrip?.from){
        case 'Damascus':
            fromser = `${t("search.Damascus")}`
            break;
        case 'Hama':
            fromser = `${t("search.Hama")}`
            break;
        case 'Alepo':
            fromser = `${t("search.Aleppo")}`
            break;
        case 'Homs':
            fromser = `${t("search.Homs")}`
            break;
        case 'Latakia':
            fromser = `${t("search.Latakia")}`
            break;
        case 'Tartous':
            fromser = `${t("search.Tartous")}`
            break;
        case 'Quneitra':
            fromser = `${t("search.Quneitra")}`
            break;     
        default:
            break;                                                                           
        }
    switch (selectedTrip?.to){
        case 'Damascus':
            toser = `${t("search.Damascus")}`
            break;
        case 'Hama':
            toser = `${t("search.Hama")}`
            break;
        case 'Alepo':
            toser = `${t("search.Aleppo")}`
            break;
        case 'Homs':
            toser = `${t("search.Homs")}`
            break;
        case 'Latakia':
            toser = `${t("search.Latakia")}`
            break;
        case 'Tartous':
            toser = `${t("search.Tartous")}`
            break;
        case 'Quneitra':
            toser = `${t("search.Quneitra")}`
            break;     
        default:
            break;                                                                           
        }
    switch (formattedDay){
        case 'Sunday':
            dayser = `${t("trip.Sunday")}`
            break;
        case 'Monday':
            dayser = `${t("trip.Monday")}`
            break;
        case 'Tuesday':
            dayser = `${t("trip.Tuesday")}`
            break;
        case 'Wednesday':
            dayser = `${t("trip.Wednesday")}`
            break;
        case 'Thursday':
            dayser = `${t("trip.Thursday")}`
            break;
        case 'Friday':
            dayser = `${t("trip.Friday")}`
            break;
        case 'Saturday':
            dayser = `${t("trip.Saturday")}`
            break;     
        default:
            break;                                                                           
        }
    useEffect(() => {
        const updatedChears = [];
        for (let i = 1; i <= selectedTrip?.bus.numOfSets; i++) {
          updatedChears?.push({ id: i, reserved: false, check: false });
        }
        setChears(updatedChears);
        console.log(updatedChears);

      }, [selectedTrip,setChears]);
    console.log(selectedChears)
    useEffect(() => {
        // Calculate the price based on the selected seats
        const totalPrice = selectedChears?.length * selectedTrip?.ticktPrice;
        setPrice(totalPrice);
      }, [selectedChears, selectedTrip,setPrice]);
  return (
    <div className='main_reservecear'>
        <div className='trip_main' >
            <div className='trip_div1'>
                {selectedTrip?.id}
            </div>
            <div className='trip_div2'>
                <p style={{fontWeight:'bold'}}>{selectedTrip?.companyName}</p>
            </div>
            <div className='trip_div3'>
                <div className='trip_h2' style={{flexDirection:lang?'row-reverse':'row'}}>
                    <p className='trip_para'>{t("trip.from")}</p>
                    <span className='trip_para'>:</span>
                    <p className='trip_para'>{fromser}</p>
                </div>
                <div className='trip_h2' style={{flexDirection:lang?'row-reverse':'row'}}>
                    <p className='trip_para'>{t("trip.to")}</p>
                    <span className='trip_para'>:</span>
                    <p className='trip_para'>{toser}</p>
                </div>
                <div className='trip_h2' style={{flexDirection:lang?'row-reverse':'row'}}>
                    <p className='trip_para'>{t("trip.busnumber")}</p>
                    <span className='trip_para'>:</span>
                    <p className='trip_para'>{selectedTrip?.bus?.numberOfBus}</p>
                </div>
                <div className='trip_h2' style={{flexDirection:lang?'row-reverse':'row'}}>
                    <p className='trip_para'>{t("trip.bustype")}</p>
                    <span className='trip_para'>:</span>
                    <p className='trip_para'>{selectedTrip?.bus?.type}</p>
                </div>
                <div className='trip_h2' style={{flexDirection:lang?'row-reverse':'row'}}>
                    <p className='trip_para'>{t("trip.numberofseats")} </p>
                    <span className='trip_para'>:</span>
                    <p className='trip_para'>{selectedTrip?.bus?.numOfSets}</p>
                </div>
            </div>
            <div className='trip_div5'>
                <div className='trip_h2' style={{flexDirection:lang?'row-reverse':'row'}}>
                    <p className='trip_para'>{t("trip.day")} </p>
                    <span className='trip_para'>:</span>
                    <p className='trip_para'>{dayser}</p>
                </div>
                <p>{t("trip.date")} : {formattedDate}</p>
                <p style={{marginTop:'5px'}}>{t("trip.time")} : {formattedTime}</p>
                <div className='trip_h2' style={{flexDirection:lang?'row-reverse':'row'}}>
                    <p className='trip_para'>{t("trip.price")} </p>
                    <span className='trip_para'>:</span>
                    <p className='trip_para'>{selectedTrip?.ticktPrice}</p>
                </div>
            </div>
        </div>
        <div className='separator' style={{
            flexDirection:lang ? width > 1000 ? 'row-reverse' : 'column-reverse' : width > 1000 ? 'row' :  'column-reverse',
        }}>
                <div className='fourth_container' 
                    style={{
                        // marginLeft:width > 600 && lang?'100px':'0px',marginRight:width > 600 && !lang?'100px':'0px',
                            justifyContent:lang?'flex-end':'flex-start'
                            // ,marginTop:width<1000 ? '50px' : '0px'
                        }}>
                    <div className='fourth_h1' style={{alignItems:lang?'flex-end':'flex-start',display:width<1000 ? 'none' : 'flex'}}>
                        <p className='fourth_para'>{t("fourth.make")}</p>
                        <p className='fourth_para'>{t("fourth.make1")}</p>
                    </div>
                    <div className='fourth_h2' style={{alignItems:lang?'flex-end':'flex-start',display:width<1000 ? 'none' : 'flex'}}>
                        <p className='fourth_para'>{t("fourth.facility")}</p>
                        <p className='fourth_para'>{t("fourth.facility1")}</p>
                    </div>
                    <div className='fourth_h3' style={{justifyContent:lang?'flex-end':'flex-start',marginTop:width<1000?'0px':'40px',marginBottom:width<1000?'40px':'0px'}}>
                        <button className='fourth_sign' onClick={checkchears}>{t("reserve.continuo")}</button>
                    </div>
                </div>
            <div>
                <div className='bus_chears_details'>
                    <div>
                        <p style={{fontWeight:'bold',textAlign:lang?'right':'left'}}>{t("reserve.please")}</p>
                    </div>
                    <div className='details_container'>
                        <div className='smaller'>
                            <p>{t("reserve.availabile")}</p>
                            <p className='span' style={{backgroundColor:'rgb(20,138,117)'}}></p>
                        </div>
                        <div className='smaller'>
                            <p>{t("reserve.busy")}</p>
                            <p className='span' style={{backgroundColor:'rgb(285,5,5)'}}></p>
                        </div>
                        <div className='smaller'>
                            <p>{t("reserve.yours")}</p>
                            <p className='span' style={{backgroundColor:'rgb(35,56,98)'}}></p>
                        </div>
                    </div>
                </div>
                <div className='bus_chears_colors'>
                {chears.map((chear) => (
                    <div
                        key={chear.id}
                        className="chear"
                        style={{
                        backgroundColor: chear.reserved ? "red" : chear.check ? "rgb(35,56,98)" : "rgb(20,138,117)",
                        // backgroundColor: chear.id === 6 ? "rgb(285,5,5)" : chear.check ? "rgb(35,56,98)" : "rgb(20,138,117)",
                        marginRight: chear.id === 2 || chear.id === 6 || chear.id === 10 || chear.id === 14 || chear.id === 18 || chear.id === 24 || chear.id === 28 ? "48px" : chear.id === 22 ? '134px' : '',
                        }}
                        onClick={() => {
                            if(!chear.reserved){
                                setChears((prevChears) => {
                                    const updatedChears = prevChears.map((chear11) => {
                                    if (chear11.id === chear.id) {
                                        return { ...chear, check: !chear.check };
                                    }
                                    return chear11;
                                    });
                                    return updatedChears;
                                });
                                if (!chear.check) {
                                    setSelectedChears((selectedChears) => [...selectedChears, chear.id]);
                                } 
                                else {
                                    setSelectedChears((selectedChears) =>
                                        selectedChears.filter((chearf) => chearf !== chear.id)
                                    );
                                }
                            }
                        }}
                    >
                        {chear.id}
                    </div>
                ))}
                </div>
                <div className='bus_chears_price'>
                    <div className='trip_h2' style={{flexDirection:lang?'row-reverse':'row'}}>
                            <p className='trip_para'>{t("trip.price")} </p>
                            <span className='trip_para'>:</span>
                            <p className='trip_para'>{price}</p>
                            {/* <span className='trip_para'>{t("trip.sp")}</span> */}
                    </div>
                    <div className='trip_h2' style={{flexDirection:lang?'row-reverse':'row'}}>
                            <p className='trip_para'>{t("trip.numberofseats")} </p>
                            <span className='trip_para'>:</span>
                            <p className='trip_para'>{selectedChears?.length}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ReserveChear